/**
 * Comparator for keys that are *usually* numeric strings.
 * Falls back to locale-aware (numeric) string ordering so charts remain
 * deterministic even when the API returns non-numeric step/error ids.
 */
export const compareNumericStringKeys = (a: string, b: string): number => {
  const numA = Number(a);
  const numB = Number(b);
  if (isFinite(numA) && isFinite(numB)) return numA - numB;
  return a.localeCompare(b, undefined, { numeric: true });
};
